module.exports = "body{\r\n    padding:0px !important;\r\n    position:relative;min-height:100vh;\r\n    /* background: #083269; */\r\n    background: url(/assets/images/loginbg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n   \r\n}\r\n.send{\r\n    margin-top: 29px;\r\n    margin-left: -75px;\r\n}\r\n.back{\r\n    margin-top: 10px;\r\n    margin-left: 5px;\r\n}\r\n.forgot{\r\n    width:400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/forgot-password/forgot-password.component.css
// module id = ./src/app/registration/forgot-password/forgot-password.component.css
// module chunks = main